<template>
  <div>
    <!-- Botão global para parar ligação (fora de qualquer container) -->
    <div v-if="isCalling" class="global-call-control-panel">
      <div class="call-info">
        <i class="fas fa-phone text-success mr-2"></i>
        <span>Chamada ativa: {{ currentCallNumber }}</span>
      </div>
      <button
        @click="stopCall"
        class="btn btn-danger btn-sm stop-call-btn"
        title="Encerrar chamada"
      >
        <i class="fas fa-phone-slash mr-1"></i>
        Encerrar
      </button>
    </div>

    <div class="animated fadeIn">
      <div class="table-responsive pt-2" v-if="phones && phones.length > 0">
      <table class="table table-hover" style="border: 1px solid #dcdede">
        <thead class="thead-third" style="border: solid 1px #04a791">
          <tr>
            <th class="text-center" style="font-size: 10px">
              CONTATO
            </th>
            <th class="text-center" style="font-size: 10px">
              TIPO
            </th>
            <th class="text-center" style="font-size: 10px">
              AÇÃO
            </th>
          </tr>
        </thead>
        <tbody v-if="phones && phones.length > 0">
          <tr v-for="(obj, index) in phones" :key="index">
            <td class="text-center">
              <a :href="`tel:${obj.telefone}`">{{ obj.telefone }}</a>
            </td>
            <td class="text-center" style="font-size: 11px">
              {{ obj.tipoContato }}
            </td>
            <td
              @click="openShowMessages(card, obj.telefone)"
              class="text-center"
              style="font-size: 14px; cursor: pointer"
            >
              <i :class=" obj.tipoContato === 'CELULAR' ? 'fab fa-whatsapp' : 'fas fa-phone-alt' "></i>
              <i
                v-if="hasVoipAccess"
                @click.stop="callPhone(obj.telefone)"
                class="fas fa-headset"
                :class="{ 'text-success': isCalling }"
                :title="isCalling ? 'Chamada em andamento...' : 'Fazer chamada VoIP'"
              ></i>
            </td>
          </tr>
          <tr v-if="card.pessoa.email">
            <td class="text-center">
              <a :href="`mailto:${card.pessoa.email}`">{{
                card.pessoa.email
              }}</a>
            </td>
            <td class="text-center" style="font-size: 11px">
              E-MAIL
            </td>
            <td
              @click="toastInfo"
              class="text-center"
              style="font-size: 14px; cursor: pointer"
            >
              <i class="fas fa-mail-bulk"></i>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="2" class="text-center">
              {{ $lang.Common.DataTable.NoRecordsFound }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else-if="phones && phones.length === 0 && cardActive">
      Nenhum registro de contato,
      <strong @click="onAddPhone" style="cursor: pointer"
        >clique para adicionar</strong
      >
    </div>
    <AssociateCreate
      class="pos"
      ref="newConversationModal"
      :conversationInfo="conversationAssociate"
    />
    <ModalAddPhone ref="ModalAddPhone" :card="card" v-on:Reload="onReload" />
    </div>
  </div>
</template>
<script>
import CrmDetailsContacts from './contact.js'
export default CrmDetailsContacts
</script>

<style scoped>
  .pos {
    position: absolute;
    top: 50%;
    right: 0%;
    transform: translate(-50%, -50%);
  }

  .global-call-control-panel {
    position: fixed;
    top: 20px;
    right: 20px;
    background: white;
    border: 2px solid #28a745;
    border-radius: 8px;
    padding: 12px 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 99999;
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 250px;
  }

  .call-info {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: #28a745;
  }

  .stop-call-btn {
    font-size: 12px;
    padding: 6px 12px;
    border-radius: 4px;
  }

  .stop-call-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
  }
</style>



// WEBPACK FOOTER //
// src/views/private/crm/details/contacts/Contact.vue